// if adding a new event - don't forget to add it to eventregistry.ts
export var BiEventType;
(function (BiEventType) {
    BiEventType[BiEventType["DEFAULT"] = 2] = "DEFAULT";
    BiEventType[BiEventType["CLICK_REPORT_BUTTON"] = 20] = "CLICK_REPORT_BUTTON";
    BiEventType[BiEventType["SCROLL_TO_LOAD_NEXT_FOLDER"] = 96] = "SCROLL_TO_LOAD_NEXT_FOLDER";
    BiEventType[BiEventType["BACK_TO_TOP"] = 97] = "BACK_TO_TOP";
    BiEventType[BiEventType["SCROLL_TO_LOAD_MORE"] = 98] = "SCROLL_TO_LOAD_MORE";
    BiEventType[BiEventType["PAGEVIEW"] = 99] = "PAGEVIEW";
    BiEventType[BiEventType["ITEM_CLICK"] = 100] = "ITEM_CLICK";
    BiEventType[BiEventType["USERNAME_CLICK"] = 101] = "USERNAME_CLICK";
    BiEventType[BiEventType["THUMB_FAVE"] = 102] = "THUMB_FAVE";
    BiEventType[BiEventType["THUMB_CLICK_LOVE_METER"] = 103] = "THUMB_CLICK_LOVE_METER";
    BiEventType[BiEventType["THUMB_SELECT_LOVE"] = 104] = "THUMB_SELECT_LOVE";
    BiEventType[BiEventType["THUMB_CLICK_COMMENT"] = 105] = "THUMB_CLICK_COMMENT";
    BiEventType[BiEventType["SEE_ALL_CLICK"] = 106] = "SEE_ALL_CLICK";
    BiEventType[BiEventType["USERNAME_HOVER_TO_OPEN"] = 107] = "USERNAME_HOVER_TO_OPEN";
    BiEventType[BiEventType["CAROUSEL_ARROW_CLICK"] = 108] = "CAROUSEL_ARROW_CLICK";
    BiEventType[BiEventType["THUMB_CLICK_UNFAVE"] = 109] = "THUMB_CLICK_UNFAVE";
    BiEventType[BiEventType["SHOW_LESS_LIKE_THIS"] = 110] = "SHOW_LESS_LIKE_THIS";
    BiEventType[BiEventType["CONTENT_NAVBAR_CLICK"] = 120] = "CONTENT_NAVBAR_CLICK";
    BiEventType[BiEventType["SORT_TYPE_SELECT"] = 122] = "SORT_TYPE_SELECT";
    BiEventType[BiEventType["FACET_CONTROL_TOGGLE"] = 124] = "FACET_CONTROL_TOGGLE";
    BiEventType[BiEventType["FACET_SELECT"] = 125] = "FACET_SELECT";
    BiEventType[BiEventType["SEARCH_TAG_CLICK"] = 140] = "SEARCH_TAG_CLICK";
    BiEventType[BiEventType["COMMENT_ACTION"] = 180] = "COMMENT_ACTION";
    BiEventType[BiEventType["CLICK_REPLY_TO_COMMENT"] = 181] = "CLICK_REPLY_TO_COMMENT";
    BiEventType[BiEventType["LOAD_MORE_COMMENTS_CLICK"] = 182] = "LOAD_MORE_COMMENTS_CLICK";
    BiEventType[BiEventType["CLICK_ON_COMMENTS_TO_START_TYPING"] = 183] = "CLICK_ON_COMMENTS_TO_START_TYPING";
    BiEventType[BiEventType["COMMENT_BUTTON_CLICK"] = 184] = "COMMENT_BUTTON_CLICK";
    BiEventType[BiEventType["CLICK_VIEW_REPLY_TO_COMMENT"] = 185] = "CLICK_VIEW_REPLY_TO_COMMENT";
    BiEventType[BiEventType["CLICK_COMMENT_LIKE"] = 186] = "CLICK_COMMENT_LIKE";
    BiEventType[BiEventType["COMMENT_EDIT_CLICK"] = 187] = "COMMENT_EDIT_CLICK";
    BiEventType[BiEventType["COMMENT_DELETION_UNDO"] = 188] = "COMMENT_DELETION_UNDO";
    BiEventType[BiEventType["COMMENT_CANCEL_CLICK"] = 189] = "COMMENT_CANCEL_CLICK";
    BiEventType[BiEventType["PROFILE_NAV_BAR"] = 200] = "PROFILE_NAV_BAR";
    BiEventType[BiEventType["LOGIN_SCREEN_SHOW"] = 201] = "LOGIN_SCREEN_SHOW";
    BiEventType[BiEventType["LOGIN_SCREEN_SUBMIT"] = 202] = "LOGIN_SCREEN_SUBMIT";
    BiEventType[BiEventType["LOGIN_ERROR"] = 203] = "LOGIN_ERROR";
    BiEventType[BiEventType["LOGIN_REMEMBER_CLICK"] = 204] = "LOGIN_REMEMBER_CLICK";
    BiEventType[BiEventType["LOGIN_FORGOT_PASSWORD_CLICK"] = 205] = "LOGIN_FORGOT_PASSWORD_CLICK";
    BiEventType[BiEventType["TERMS_CLICK"] = 206] = "TERMS_CLICK";
    BiEventType[BiEventType["POLICY_CLICK"] = 207] = "POLICY_CLICK";
    BiEventType[BiEventType["CONNECT_WITH_CLICK"] = 208] = "CONNECT_WITH_CLICK";
    BiEventType[BiEventType["CONNECT_WITH_FAILURE"] = 209] = "CONNECT_WITH_FAILURE";
    BiEventType[BiEventType["CONNECT_WITH_SUCCESS"] = 210] = "CONNECT_WITH_SUCCESS";
    BiEventType[BiEventType["LOGIN_SUCCESS"] = 211] = "LOGIN_SUCCESS";
    BiEventType[BiEventType["FIRST_LOGGIN_START_SHOW"] = 212] = "FIRST_LOGGIN_START_SHOW";
    BiEventType[BiEventType["FIRST_LOGGIN_START_SUBMIT"] = 213] = "FIRST_LOGGIN_START_SUBMIT";
    BiEventType[BiEventType["FIRST_LOGGIN_START_SUCCESS"] = 214] = "FIRST_LOGGIN_START_SUCCESS";
    BiEventType[BiEventType["FIRST_LOGGIN_START_FAILURE"] = 215] = "FIRST_LOGGIN_START_FAILURE";
    BiEventType[BiEventType["WELCOME_SCREEN_SHOW"] = 216] = "WELCOME_SCREEN_SHOW";
    BiEventType[BiEventType["WELCOME_SCREEN_CLOSE"] = 217] = "WELCOME_SCREEN_CLOSE";
    BiEventType[BiEventType["WELCOME_START_CLICK"] = 218] = "WELCOME_START_CLICK";
    BiEventType[BiEventType["WELCOME_CHANGE_EMAIL_CLICK"] = 219] = "WELCOME_CHANGE_EMAIL_CLICK";
    BiEventType[BiEventType["INTENT_SHOW"] = 220] = "INTENT_SHOW";
    BiEventType[BiEventType["INTENT_OPTION_TOGGLE"] = 221] = "INTENT_OPTION_TOGGLE";
    BiEventType[BiEventType["INTENT_OTHER_TOGGLE"] = 222] = "INTENT_OTHER_TOGGLE";
    BiEventType[BiEventType["INTENT_OTHER_DONE"] = 223] = "INTENT_OTHER_DONE";
    BiEventType[BiEventType["INTENT_OTHER_CANCEL"] = 224] = "INTENT_OTHER_CANCEL";
    BiEventType[BiEventType["INTENT_SKIP"] = 225] = "INTENT_SKIP";
    BiEventType[BiEventType["INTENT_SUBMIT"] = 226] = "INTENT_SUBMIT";
    BiEventType[BiEventType["LOGIN_CAPTCHA_SHOW"] = 227] = "LOGIN_CAPTCHA_SHOW";
    BiEventType[BiEventType["ALMOST_DONE_SHOW"] = 228] = "ALMOST_DONE_SHOW";
    BiEventType[BiEventType["ALMOST_DONE_RESEND_CLICK"] = 229] = "ALMOST_DONE_RESEND_CLICK";
    BiEventType[BiEventType["ALMOST_DONE_CHANGE_ADDRESS_CLICK"] = 230] = "ALMOST_DONE_CHANGE_ADDRESS_CLICK";
    BiEventType[BiEventType["ALMOST_DONE_CLOSE"] = 231] = "ALMOST_DONE_CLOSE";
    BiEventType[BiEventType["VERIFICATION_SUCCESSFUL_BROWSE_ART_CLICK"] = 234] = "VERIFICATION_SUCCESSFUL_BROWSE_ART_CLICK";
    BiEventType[BiEventType["REDIRECT_TO_LOGIN"] = 240] = "REDIRECT_TO_LOGIN";
    BiEventType[BiEventType["SIGNUP_SCREEN_SHOW"] = 243] = "SIGNUP_SCREEN_SHOW";
    BiEventType[BiEventType["LOGIN_SCREEN_SIGNUP_CLICK"] = 244] = "LOGIN_SCREEN_SIGNUP_CLICK";
    BiEventType[BiEventType["LOGIN_ON_SIGNUP_CLICK"] = 245] = "LOGIN_ON_SIGNUP_CLICK";
    BiEventType[BiEventType["SIGNUP_ON_SIGNUP_CLICK"] = 247] = "SIGNUP_ON_SIGNUP_CLICK";
    BiEventType[BiEventType["SIGNUP_SUCCESS"] = 248] = "SIGNUP_SUCCESS";
    BiEventType[BiEventType["SIGNUP_ERROR"] = 249] = "SIGNUP_ERROR";
    BiEventType[BiEventType["PROFILE_LOAD_MORE_CLICK"] = 265] = "PROFILE_LOAD_MORE_CLICK";
    BiEventType[BiEventType["SEND_NOTE_CLICK"] = 273] = "SEND_NOTE_CLICK";
    BiEventType[BiEventType["GIFT_CLICK"] = 274] = "GIFT_CLICK";
    BiEventType[BiEventType["GIFT_SELECT_CLICK"] = 275] = "GIFT_SELECT_CLICK";
    BiEventType[BiEventType["PROFILE_COVER_CLICK"] = 276] = "PROFILE_COVER_CLICK";
    BiEventType[BiEventType["PROFILE_WATCH_INTRO"] = 277] = "PROFILE_WATCH_INTRO";
    BiEventType[BiEventType["EDIT_WIDGET_CLICK"] = 278] = "EDIT_WIDGET_CLICK";
    BiEventType[BiEventType["ADJUST_COVER_POSITION"] = 279] = "ADJUST_COVER_POSITION";
    BiEventType[BiEventType["REMOVE_WIDGET_CLICK"] = 280] = "REMOVE_WIDGET_CLICK";
    BiEventType[BiEventType["MOVE_WIDGET_CLICK"] = 281] = "MOVE_WIDGET_CLICK";
    BiEventType[BiEventType["ADD_WIDGET_CLICK"] = 282] = "ADD_WIDGET_CLICK";
    BiEventType[BiEventType["ADD_WIDGET"] = 283] = "ADD_WIDGET";
    BiEventType[BiEventType["ADD_NEW_CONTENT_CLICK"] = 284] = "ADD_NEW_CONTENT_CLICK";
    BiEventType[BiEventType["DONATE_POINTS_CLICK"] = 286] = "DONATE_POINTS_CLICK";
    BiEventType[BiEventType["OPEN_FOR_COMMISSION_CLICK"] = 287] = "OPEN_FOR_COMMISSION_CLICK";
    BiEventType[BiEventType["PROFILE_GALLERY_VIEW_MODE_CLICK"] = 288] = "PROFILE_GALLERY_VIEW_MODE_CLICK";
    BiEventType[BiEventType["GALLERY_SEARCH_CLICK"] = 289] = "GALLERY_SEARCH_CLICK";
    BiEventType[BiEventType["PROFILE_SUB_NAV_BAR"] = 290] = "PROFILE_SUB_NAV_BAR";
    BiEventType[BiEventType["PROFILE_ABOUT_SIDEBAR"] = 291] = "PROFILE_ABOUT_SIDEBAR";
    BiEventType[BiEventType["PROFILE_SUB_NAV_BAR_TOGGLE"] = 292] = "PROFILE_SUB_NAV_BAR_TOGGLE";
    BiEventType[BiEventType["PROFILE_ORDER_COMMISSION"] = 293] = "PROFILE_ORDER_COMMISSION";
    BiEventType[BiEventType["DONATION_POOL_SETUP_CONFIRM"] = 296] = "DONATION_POOL_SETUP_CONFIRM";
    BiEventType[BiEventType["CLICK_SOCIAL_LINK"] = 297] = "CLICK_SOCIAL_LINK";
    BiEventType[BiEventType["PROFILE_BADGE_CLICK"] = 298] = "PROFILE_BADGE_CLICK";
    BiEventType[BiEventType["GALLECTION_SEARCH_SUBMIT"] = 299] = "GALLECTION_SEARCH_SUBMIT";
    BiEventType[BiEventType["NAVIGATION_ARROW_CLICK"] = 300] = "NAVIGATION_ARROW_CLICK";
    BiEventType[BiEventType["THEATRE_MODE"] = 301] = "THEATRE_MODE";
    BiEventType[BiEventType["FULLSCREEN_MODE"] = 302] = "FULLSCREEN_MODE";
    BiEventType[BiEventType["ZOOM_MODE"] = 303] = "ZOOM_MODE";
    BiEventType[BiEventType["BACK_TO_CLICK"] = 304] = "BACK_TO_CLICK";
    BiEventType[BiEventType["ADD_TO_COLLECTION_CLICK"] = 330] = "ADD_TO_COLLECTION_CLICK";
    BiEventType[BiEventType["ADD_TO_COLLECTION_DONE_CLICK"] = 331] = "ADD_TO_COLLECTION_DONE_CLICK";
    BiEventType[BiEventType["POPUP_CLICK_UNDO_FAVE"] = 332] = "POPUP_CLICK_UNDO_FAVE";
    BiEventType[BiEventType["POPUP_CLICK_ADD_TO_COLLECTION"] = 333] = "POPUP_CLICK_ADD_TO_COLLECTION";
    BiEventType[BiEventType["ADD_TO_GROUP_CLICK"] = 340] = "ADD_TO_GROUP_CLICK";
    BiEventType[BiEventType["ADD_TO_GROUP_FOLDER_SELECT"] = 342] = "ADD_TO_GROUP_FOLDER_SELECT";
    BiEventType[BiEventType["ADD_TO_GROUP_SELECT"] = 341] = "ADD_TO_GROUP_SELECT";
    BiEventType[BiEventType["CLICK_DOWNLOAD_BUTTON"] = 350] = "CLICK_DOWNLOAD_BUTTON";
    BiEventType[BiEventType["DOWNLOAD_NOW_CLICK"] = 351] = "DOWNLOAD_NOW_CLICK";
    BiEventType[BiEventType["CLICK_SHARE"] = 355] = "CLICK_SHARE";
    BiEventType[BiEventType["CLICK_SOCIAL_SHARE"] = 356] = "CLICK_SOCIAL_SHARE";
    BiEventType[BiEventType["CLICK_COPY"] = 357] = "CLICK_COPY";
    BiEventType[BiEventType["BUY_CLICK"] = 360] = "BUY_CLICK";
    BiEventType[BiEventType["CHANGE_BACKGROUND_CLICK"] = 370] = "CHANGE_BACKGROUND_CLICK";
    BiEventType[BiEventType["DEVIATION_EDIT_CLICK"] = 371] = "DEVIATION_EDIT_CLICK";
    BiEventType[BiEventType["DEVIATION_DELETE_CLICK"] = 372] = "DEVIATION_DELETE_CLICK";
    BiEventType[BiEventType["SELECT_BACKGROUND"] = 373] = "SELECT_BACKGROUND";
    BiEventType[BiEventType["CLOSE_BACKGROUND_SELECTION_MODAL"] = 374] = "CLOSE_BACKGROUND_SELECTION_MODAL";
    BiEventType[BiEventType["BUY_CORE_BUTTON"] = 375] = "BUY_CORE_BUTTON";
    BiEventType[BiEventType["WATCH_AUTHOR"] = 380] = "WATCH_AUTHOR";
    BiEventType[BiEventType["FACET_CLICK"] = 390] = "FACET_CLICK";
    BiEventType[BiEventType["TAG_CLICK"] = 391] = "TAG_CLICK";
    BiEventType[BiEventType["SUBJECT_CLICK"] = 392] = "SUBJECT_CLICK";
    BiEventType[BiEventType["LOCATION_CLICK"] = 393] = "LOCATION_CLICK";
    BiEventType[BiEventType["WATCH_SECTION_SELECT"] = 400] = "WATCH_SECTION_SELECT";
    BiEventType[BiEventType["CHANGE_FEED_MODE"] = 401] = "CHANGE_FEED_MODE";
    BiEventType[BiEventType["USER_OR_GROUP_FEED_SELECT"] = 402] = "USER_OR_GROUP_FEED_SELECT";
    BiEventType[BiEventType["FEED_SORT_ORDER_SELECT"] = 403] = "FEED_SORT_ORDER_SELECT";
    BiEventType[BiEventType["MANAGE_WATCHLIST"] = 404] = "MANAGE_WATCHLIST";
    BiEventType[BiEventType["WATCH_ITEM_REMOVE_CLICK"] = 405] = "WATCH_ITEM_REMOVE_CLICK";
    BiEventType[BiEventType["WATCH_SUGGESTION_REMOVE_CLICK"] = 406] = "WATCH_SUGGESTION_REMOVE_CLICK";
    BiEventType[BiEventType["WATCH_FILTER_TAB_SELECTION"] = 407] = "WATCH_FILTER_TAB_SELECTION";
    BiEventType[BiEventType["WATCH_FILTER_SEARCH_ICON_CLICK"] = 408] = "WATCH_FILTER_SEARCH_ICON_CLICK";
    BiEventType[BiEventType["WATCH_FILTER_CLOSE_SEARCH_CLICK"] = 409] = "WATCH_FILTER_CLOSE_SEARCH_CLICK";
    BiEventType[BiEventType["WATCH_FILTER_SEARCH"] = 410] = "WATCH_FILTER_SEARCH";
    BiEventType[BiEventType["WATCH_FILTER_SELECT_ALL_CLICK"] = 411] = "WATCH_FILTER_SELECT_ALL_CLICK";
    BiEventType[BiEventType["WATCH_GROUP_BY_ARTIST_CLICK"] = 412] = "WATCH_GROUP_BY_ARTIST_CLICK";
    BiEventType[BiEventType["WATCH_VIEW_ALL_BY_ARTIST"] = 413] = "WATCH_VIEW_ALL_BY_ARTIST";
    BiEventType[BiEventType["WATCH_DEVIATION_SELECT"] = 414] = "WATCH_DEVIATION_SELECT";
    BiEventType[BiEventType["WATCH_DEVIATION_DESELECT"] = 415] = "WATCH_DEVIATION_DESELECT";
    BiEventType[BiEventType["WATCH_CONFIRM_REMOVAL"] = 416] = "WATCH_CONFIRM_REMOVAL";
    BiEventType[BiEventType["WATCH_MORE_MENU_CLICK"] = 417] = "WATCH_MORE_MENU_CLICK";
    BiEventType[BiEventType["WATCH_POPUP_SAVE"] = 418] = "WATCH_POPUP_SAVE";
    BiEventType[BiEventType["WATCH_POPUP_REMOVE"] = 419] = "WATCH_POPUP_REMOVE";
    BiEventType[BiEventType["WATCH_POPUP_CLOSE"] = 420] = "WATCH_POPUP_CLOSE";
    BiEventType[BiEventType["WATCH_POPUP_SELECT_ALL"] = 421] = "WATCH_POPUP_SELECT_ALL";
    BiEventType[BiEventType["WATCH_POPUP_SELECT_NONE"] = 422] = "WATCH_POPUP_SELECT_NONE";
    BiEventType[BiEventType["WATCH_POPUP_UNDO_REMOVAL"] = 423] = "WATCH_POPUP_UNDO_REMOVAL";
    BiEventType[BiEventType["WATCH_MENU_ITEM_SELECTION"] = 424] = "WATCH_MENU_ITEM_SELECTION";
    BiEventType[BiEventType["VIEW_MODE_SELECT"] = 620] = "VIEW_MODE_SELECT";
    BiEventType[BiEventType["ELNINO_VIEW"] = 641] = "ELNINO_VIEW";
    BiEventType[BiEventType["NOTIFICATION_CLICK"] = 650] = "NOTIFICATION_CLICK";
    BiEventType[BiEventType["NOTIFICATION_GIVE_CLICK"] = 651] = "NOTIFICATION_GIVE_CLICK";
    BiEventType[BiEventType["TOP_NAV_CLICK"] = 700] = "TOP_NAV_CLICK";
    BiEventType[BiEventType["TOP_NAV_MENU_CLICK"] = 702] = "TOP_NAV_MENU_CLICK";
    BiEventType[BiEventType["SEARCH_CLICK"] = 710] = "SEARCH_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_PREVIEW_BACK_CLICK"] = 806] = "WIX_PORTFOLIO_PREVIEW_BACK_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_CREATE_CLICK"] = 800] = "WIX_PORTFOLIO_CREATE_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_GET_STARTED_CLICK"] = 801] = "WIX_PORTFOLIO_GET_STARTED_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_FORM_BACK_CLICK"] = 803] = "WIX_PORTFOLIO_FORM_BACK_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_FORM_NEXT_CLICK"] = 804] = "WIX_PORTFOLIO_FORM_NEXT_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_KIT_NEXT_CLICK"] = 805] = "WIX_PORTFOLIO_KIT_NEXT_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_EDIT_AND_PUBLISH_CLICK"] = 807] = "WIX_PORTFOLIO_EDIT_AND_PUBLISH_CLICK";
    BiEventType[BiEventType["WIX_PORTFOLIO_CLOSE_USER_PROFILE_CTA"] = 808] = "WIX_PORTFOLIO_CLOSE_USER_PROFILE_CTA";
    BiEventType[BiEventType["PROFILE_STATS_SIDEBAR"] = 830] = "PROFILE_STATS_SIDEBAR";
    BiEventType[BiEventType["STATS_CHANGE_LEVEL_CLICK"] = 831] = "STATS_CHANGE_LEVEL_CLICK";
    BiEventType[BiEventType["STATS_OVERVIEW_TAB_CLICK"] = 832] = "STATS_OVERVIEW_TAB_CLICK";
    BiEventType[BiEventType["STATS_MY_SUBMISSIONS_SORT_CLICK"] = 833] = "STATS_MY_SUBMISSIONS_SORT_CLICK";
    BiEventType[BiEventType["CLOSE_BANNER_AD"] = 8005] = "CLOSE_BANNER_AD";
})(BiEventType || (BiEventType = {}));
export var BiDataHook;
(function (BiDataHook) {
    BiDataHook["CODEBLOCK_BUTTON"] = "code_block_button";
    BiDataHook["VIDEO_PLAYER"] = "video_player";
    BiDataHook["DROPDOWN_LAYOUT_OPTIONS"] = "dropdown_layout_options";
    BiDataHook["TOP_NAV"] = "top_nav";
    BiDataHook["DEVIATION_NAV"] = "deviation_nav";
    BiDataHook["FILTER_NAV"] = "filter_nav";
    BiDataHook["CONTENT_ROW_IDX"] = "content_row";
    BiDataHook["BROWSE_ALL_CONTENT"] = "all_content";
    BiDataHook["DEVIATION_ART_STAGE"] = "art_stage";
    BiDataHook["DEVIATION_ACTION_BAR"] = "action_bar";
    BiDataHook["DEVIATION_ADD_TO_FAVES_POPUP"] = "fave_pop_up";
    BiDataHook["DEVIATION_META"] = "deviation_meta";
    BiDataHook["DEVIATION_TITLE"] = "deviation_title";
    BiDataHook["DEVIATION_COMMENTS_COUNTER"] = "comments_counter";
    BiDataHook["DEVIATION_FAVES_COUNTER"] = "faves_counter";
    BiDataHook["DEVIATION_GROUPS_COUNTER"] = "group_counter";
    BiDataHook["DEVIATION_FAVE_BUTTON"] = "fave_button";
    BiDataHook["DEVIATION_COMMENT_BUTTON"] = "comment_button";
    BiDataHook["DEVIATION_SHARE_BUTTON"] = "share_button";
    BiDataHook["DEVIATION_WATCH_BUTTON"] = "watch_button";
    BiDataHook["DEVIATION_DOWNLOAD_BUTTON"] = "download_button";
    BiDataHook["DEVIATION_LINK"] = "deviation_link";
    BiDataHook["DEVIATION_STD_THUMB"] = "deviation_std_thumb";
    BiDataHook["DEVIATION_FAVERS_LIST"] = "favers_list";
    BiDataHook["NOTIFICATIONS_DROPDOWN"] = "feedback_dropdown";
    BiDataHook["NOTIFICATIONS_ITEM"] = "notification_item";
    BiDataHook["PROFILE_NAV"] = "profile_nav";
    BiDataHook["PROFILE_GALLECTION_FOLDER"] = "gallection_folder";
    BiDataHook["PROFILE_GALLECTION_FOLDER_ITEM"] = "gallection_folder_";
    BiDataHook["PROFILE_GALLECTION_FOLDER_CHOOSER"] = "gallection_chooser";
    BiDataHook["PROFILE_GALLECTION_FOLDER_DROPDOWN"] = "gallection_dropdown";
    BiDataHook["WIDGET_HEADER"] = "widget-header";
    BiDataHook["WIDGET_HEADER_COUNTER"] = "widget-header-counter";
    BiDataHook["WIDGET_PROFILE_COMMENTS"] = "profile-comments-widget";
    BiDataHook["FAVES_POPUP"] = "fave_pop_up";
    BiDataHook["FAVES_POPUP_MESSAGE"] = "fav_pop_up_message";
    BiDataHook["FAVE_BUTTON"] = "fave_button";
    BiDataHook["USER_WATCH_BUTTON"] = "user_watch_button";
    BiDataHook["USER_AVATAR"] = "user_avatar";
    BiDataHook["USER_LINK"] = "user_link";
    BiDataHook["COMMENTS_THREAD"] = "comments_thread";
    BiDataHook["COMMENTS_THREAD_STATS"] = "comments_thread_stats";
    BiDataHook["COMMENTS_THREAD_COUNT"] = "comments_count";
    BiDataHook["COMMENTS_THREAD_SORTING"] = "comments_sorting_order";
    BiDataHook["COMMENTS_THREAD_ITEM"] = "comments_thread_item";
    BiDataHook["COMMENT_BODY"] = "comment_body";
    BiDataHook["COMMENT_ACTION_MENU"] = "comment_action_menu";
    BiDataHook["COMMENT_FOOTER"] = "comment_footer";
    BiDataHook["COMMENT_TIMESTAMP"] = "comment_timestamp";
    BiDataHook["COMMENT_FEATURE_BUTTON"] = "comment_feature_button";
    BiDataHook["COMMENT_DELETE_BUTTON"] = "comment_delete_button";
    BiDataHook["COMMENT_BLOCK_BUTTON"] = "comment_block_button";
    BiDataHook["COMMENT_SPAM_BUTTON"] = "comment_spam_button";
    BiDataHook["COMMENT_EDIT_BUTTON"] = "comment_edit_button";
    BiDataHook["COMMENT_REPLY_BUTTON"] = "comment_reply_button";
    BiDataHook["COMMENT_LIKE_BUTTON"] = "comment_like_button";
    BiDataHook["COMMENT_EDITOR"] = "comment_editor";
})(BiDataHook || (BiDataHook = {}));
export var BiUpdateType;
(function (BiUpdateType) {
    BiUpdateType[BiUpdateType["ADD"] = 0] = "ADD";
    BiUpdateType[BiUpdateType["CHANGE"] = 1] = "CHANGE";
})(BiUpdateType || (BiUpdateType = {}));
export var ReferralType;
(function (ReferralType) {
    ReferralType["FAVOURITE"] = "favourite";
    ReferralType["ADD_TO_GROUP"] = "add_to_group";
    ReferralType["WATCH"] = "watch";
    ReferralType["EDIT_DEVIATION"] = "edit_deviation";
    ReferralType["DELETE_DEVIATION"] = "delete_deviation";
    ReferralType["MATURE"] = "mature";
    ReferralType["POLL_VOTE"] = "poll_vote";
    ReferralType["GIVE"] = "give";
    ReferralType["DONATE_POINTS"] = "donate_points";
    ReferralType["PCP"] = "pcp";
    ReferralType["COMMISSION"] = "commission";
    ReferralType["SUBMIT"] = "submit";
    ReferralType["COMMENT_ACTION"] = "comment_action";
    ReferralType["REPORT"] = "report";
    ReferralType["LOVE"] = "love";
    ReferralType["NOTE"] = "note";
    ReferralType["COMMENT"] = "comment";
    ReferralType["HEADER"] = "header";
    ReferralType["LOGIN"] = "login";
    ReferralType["ANON_DOWNLOAD"] = "anon_download";
    ReferralType["BACKGROUND_MODAL"] = "background_modal";
    ReferralType["USER_STATS"] = "user_stats";
})(ReferralType || (ReferralType = {}));
//# sourceMappingURL=constants.js.map